export default {
    watch:{
        //改變lessonExamListIndex就可改變試題
        lessonExamListIndex(val){
            switch(val){
                case -1:
                    this.$store.commit('setLessonExam',null)
                    break
                case 0:
                    this.$store.commit('setLessonExam', this.lessonExamList[0])
                    break
                default:
                    this.$store.commit('setLessonExam', this.lessonExamList[val])
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/controller/lessonExamListControlle.js